import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import swal from 'sweetalert';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import { ServerUrl } from '../../../../api/ServerUrl';
import { SetPermission } from '../../../../auth/SetPermission';
import AdminQuickNav from '../AdminQuickNav';

const ServicesIndext = () => {
  const { http } = ProtectAPi();
  const httpCPage = ServerUrl;
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const userPermission = SetPermission();
  const dataTableInstance = useRef(null);

  // 🔥 Fixed type = 2
  const type = 2;

  // Fetch services for type = 2
  useEffect(() => {
    fetchServicesByType();
  }, []);

  $.fn.dataTable.ext.errMode = "none"; // alert বন্ধ


  const fetchServicesByType = async () => {
    try {
      const res = await http.get('/get-services-list-back', { params: { type } });

      const data = Array.isArray(res.data) ? res.data : (res.data.data || res.data);
      setTableData(data);
    } catch (error) {
      console.error('Error fetching services:', error);
      setTableData([]);
    }
  };

  // DataTable init / destroy
  useEffect(() => {
    // destroy old instance
    if (dataTableInstance.current) {
      $(dataTableInstance.current).DataTable().destroy();
      dataTableInstance.current = null;
      $(`#${tableRef.current.id} tbody`).off();
    }

    if (tableData.length > 0) {
      if (!tableRef.current.id) {
        tableRef.current.id = 'table-1';
      }

      dataTableInstance.current = $(tableRef.current).DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
      });
    }

    return () => {
      if (dataTableInstance.current) {
        try {
          $(dataTableInstance.current).DataTable().destroy();
        } catch (e) {}
        dataTableInstance.current = null;
      }
    };
  }, [tableData]);

  const handleDeleteRole = (roleId) => {
    swal({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this item!',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        http.delete(`/delete-services/${roleId}`)
          .then(response => {
            if (response.data.status !== 201) {
              setTableData(prevRoles => prevRoles.filter(data => data.id !== roleId));
            }
            swal(response.data.msg, { icon: response.data.alert });
          })
          .catch(() => {
            swal('Oops! Something went wrong while deleting this item.', { icon: 'error' });
          });
      }
    });
  };

  const renderStatusBadge = (status) => {
    if (Number(status) === 1) {
      return <span className="badge badge-success">Active</span>;
    }
    if (Number(status) === 2) {
      return <span className="badge badge-danger">Inactive</span>;
    }
    return <span className="badge badge-light">N/A</span>;
  };

  return (
    <div>
      <div className="main-content" style={{ marginTop: -20 }}>
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">

                <AdminQuickNav active="services" />

                {/* Main Table */}
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-3">
                      <h5>Services List</h5>
                      <div className="text-end">
                        <Link to='/admin/landing-page/service-create' className="btn btn-primary btn-md">
                          Add New Services
                        </Link>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-striped" id="table-1" ref={tableRef}>
                        <thead>
                          <tr>
                            <th className="text-center">#</th>
                            <th>Title</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Priority</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((data, index) => (
                            <tr key={data.id}>
                              <td>{index + 1}</td>
                              <td>{data.title}</td>
                              <td>
                                <img
                                  className='p-2'
                                  alt=""
                                  src={httpCPage + '/backend/img/services/' + data.image}
                                  width="85"
                                />
                              </td>

                              <td>{renderStatusBadge(data.status)}</td>

                              <td>{data.priority ?? '—'}</td>

                              <td>
                                {userPermission.includes('services_edit') && (
                                  <Link
                                    to={`/admin/landing-page/service-edit/${data.id}`}
                                    className="editbtn mr-1"
                                  >
                                    <button className="btn btn-warning">
                                      <i className="fas me-2 fa-edit text-white"></i>
                                    </button>
                                  </Link>
                                )}

                                {userPermission.includes('services_delete') && (
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => handleDeleteRole(data.id)}
                                  >
                                    <i className="fas me-2 fa-trash text-white"></i>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ServicesIndext;
